/**
 * The visible half of `hooks/useSessionTimeout.ts` (STEP 4) — a real
 * modal warning the user before idle-timeout logs them out, with a
 * genuine "stay logged in" action that resets the idle timer.
 */
import type { JSX } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

export interface SessionTimeoutWarningProps {
  open: boolean;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export function SessionTimeoutWarning({ open, onStayLoggedIn, onLogout }: SessionTimeoutWarningProps): JSX.Element {
  return (
    <Dialog open={open} onClose={onStayLoggedIn} maxWidth="xs" fullWidth>
      <DialogTitle>You&rsquo;ve been idle</DialogTitle>
      <DialogContent>
        <Typography variant="body2">You&rsquo;ll be logged out soon due to inactivity. Do you want to stay logged in?</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="inherit">
          Log out
        </Button>
        <Button onClick={onStayLoggedIn} variant="contained">
          Stay logged in
        </Button>
      </DialogActions>
    </Dialog>
  );
}
